import { useEffect, useState } from "react";
import API from "../lib/api";
import { Key, Phone, Envelope, MapPin, Buildings } from "@phosphor-icons/react";
import What3WordsLink from "./What3WordsLink";

export default function PropertyAccessCard({ entityType, entityId, compact = false }) {
  const [data, setData] = useState(null);
  useEffect(() => {
    if (!entityId) return;
    API.get(`/property-access/${entityType}/${entityId}`).then(({ data }) => setData(data)).catch(() => setData({ found: false }));
  }, [entityType, entityId]);

  if (!data?.found) return null;
  const p = data.property;
  const hasContact = p.site_contact_name || p.site_contact_phone || p.site_contact_email;

  return (
    <div className={`border border-amber-300 dark:border-amber-800 bg-amber-50 dark:bg-amber-950/30 rounded-lg ${compact ? "p-3" : "p-4"}`} data-testid="property-access-card">
      <div className="flex items-start justify-between gap-2 mb-2">
        <h3 className="text-[10px] font-semibold uppercase tracking-wider text-amber-800 dark:text-amber-300 flex items-center gap-1"><Key size={12} weight="fill" /> Access & Site Info</h3>
        <span className="text-[10px] text-amber-700/80 dark:text-amber-400/80 flex items-center gap-1"><Buildings size={11} /> {p.name}{p.property_type ? ` · ${p.property_type}` : ""}</span>
      </div>
      {p.access_notes ? (
        <p className="text-sm font-medium whitespace-pre-wrap text-amber-950 dark:text-amber-100" data-testid="property-access-notes">{p.access_notes}</p>
      ) : (
        <p className="text-xs italic text-amber-800/70 dark:text-amber-300/70">No access notes recorded for this property.</p>
      )}
      <div className={`mt-3 grid ${compact ? "grid-cols-1" : "sm:grid-cols-2"} gap-2 text-xs`}>
        {hasContact && (
          <div data-testid="property-access-contact">
            <p className="text-[10px] uppercase tracking-wider text-amber-800/70 dark:text-amber-300/70 mb-0.5">On-site contact</p>
            {p.site_contact_name && <p className="font-semibold">{p.site_contact_name}</p>}
            {p.site_contact_phone && <a href={`tel:${p.site_contact_phone}`} className="flex items-center gap-1 text-primary hover:underline"><Phone size={12} /> {p.site_contact_phone}</a>}
            {p.site_contact_email && <a href={`mailto:${p.site_contact_email}`} className="flex items-center gap-1 text-primary hover:underline truncate"><Envelope size={12} /> {p.site_contact_email}</a>}
          </div>
        )}
        <div>
          <p className="text-[10px] uppercase tracking-wider text-amber-800/70 dark:text-amber-300/70 mb-0.5">Registered address</p>
          <p className="flex items-start gap-1"><MapPin size={12} className="shrink-0 mt-0.5" /> {p.address}</p>
          {p.what3words && <div className="mt-1"><What3WordsLink words={p.what3words} /></div>}
        </div>
      </div>
      <p className="text-[10px] text-amber-700/70 dark:text-amber-400/70 mt-2">Provided by the client via their portal{data.source === "postcode_match" ? " (matched by postcode)" : ""}.</p>
    </div>
  );
}
